module.exports = __webpack_public_path__ + "img/performance.afd39a46.png";